// Sentry first, so anything that throws from here on is reported.
import './instrument';
import 'reflect-metadata';
// Register the synchronous localStorage-backed storage service BEFORE importing
// App — App transitively imports the shared persist stores, which hydrate
// synchronously at module-eval time and must find the storage service already
// registered.
import '@/bootstrap';
import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { setDisplayLocale } from '@personal-trainer-app/shared/src/utils/date';

import App from './App';
import './index.css';
import { initializeWebServices } from './services';

// Synchronous, and before render: pages resolve storage-backed services during
// their first render, and Sentry reporting is wired here too.
initializeWebServices();
// Dates a person reads follow the browser's region (the words stay English).
setDisplayLocale(navigator.language);

// React 19 root hooks: errors no boundary caught, and ones React recovered
// from. Not onCaughtError — the error boundaries report what they catch
// themselves (reportBoundaryError), so wiring it would report those twice.
createRoot(document.getElementById('root')!, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <App />
  </StrictMode>
);
